import {
  Card,
  Column,
  Columns,
  Container,
  Image,
} from '@codeparva/ui-components-library';
import React, { useEffect } from 'react';
import { CallToActionButton } from '../../../../components/ctaButton/CTAButton';
import { Gallery } from '../../../../components/gallery/Gallery';
import { CPImage } from '../../../../components/imageWrapper/CPImage';
import { Row } from '../../../../components/row/Row';
import {
  desktopscreensize,
  tabletscreensize,
  widescreensize,
} from '../../../../utilities/constants';
import { useWindowDimensions } from '../../../../utilities/Dimensions';
import { weakKey } from '../../../../utilities/weakKey';
import Carousel, {
  CarouselItem,
} from '../jumbotron/components/carousel/Carousel';
import { AboutUsTypes } from './AboutUsTypes';

export const AboutUs = ({
  title,
  description,
  customArt,
  callToAction,
  theme = 'light',
  variant,
}: AboutUsTypes.IAboutUs) => {
  const { width } = useWindowDimensions();

  useEffect(() => {
    if (width <= widescreensize) {
      let element = document.getElementById('aboutUsCardText');
      element && element.classList.remove('card');
    }
  }, [width]);

  const getThemeColors = () => {
    switch (theme) {
      case 'dark':
        return {
          sectionBackgroundColor: 'primary',
          titleColor: 'white',
        };
      default:
        return {
          sectionBackgroundColor: 'secondary',
          titleColor: 'text-color-primary',
        };
    }
  };

  const { sectionBackgroundColor, titleColor } = getThemeColors();
  const getMyTitleDescriptionClassnames = () => {
    if (customArt) {
      const { position = 'left', show = true } = customArt;
      return show && position === 'right' ? 'mr-0' : '';
    }
    return '';
  };

  const renderAboutUsHeading = () => (
    <div className="is-flex">
      <span className={`aboutUsHeading`}></span>
      <div
        className={`has-text-${
          customArt?.images.length === 1 ? 'black' : titleColor
        }`}
      >
        <h3>{title}</h3>
      </div>
    </div>
  );
  const renderTitleDescription = () => {
    return (
      <>
        {width >= tabletscreensize ? renderAboutUsHeading() : null}
        <div
          dangerouslySetInnerHTML={{ __html: description }}
          className={`descriptionContainer descriptionContainerPadding has-theme-${theme}
          ${width >= tabletscreensize ? 'aboutUsCustomPadding' : null}
           ${
             variant === 'imageWithButton'
               ? 'has-text-justified'
               : 'has-text-center'
           }`}
        ></div>
        {callToAction && callToAction.show && (
          <Row
            className={` ${width <= tabletscreensize &&
              'is-align-items-center'}`}
          >
            <CallToActionButton {...callToAction} />
          </Row>
        )}
      </>
    );
  };
  const TitleDescription = () => {
    return (
      <Column
        size={customArt?.show && width > desktopscreensize ? 8 : 12}
        className={`textContainer ${getMyTitleDescriptionClassnames()}`}
      >
        {renderTitleDescription()}
      </Column>
    );
  };

  const renderSingleImage = (media: any, maxWidth: any) => (
    <>
      {media[0].gatsbyImageData ? (
        <CPImage
          gatsbyImageData={media[0].gatsbyImageData}
          className="aboutUsCPImage"
        />
      ) : (
        <Image
          src={media[0].imageUrl}
          size={maxWidth}
          fullwidth={maxWidth === 'full-size'}
          style={{
            width: '100%',
            height: '100%',
            maxWidth: maxWidth !== 'full-size' ? maxWidth : undefined,
          }}
        />
      )}
    </>
  );

  const renderCarousel = (media: any, maxWidth: any) => (
    <>
      {width <= tabletscreensize ? <>{renderAboutUsHeading()}</> : null}
      <Carousel>
        {media &&
          media.map((imagesSrc: any) => (
            <CarouselItem width="100%" key={weakKey(imagesSrc)}>
              <div className="customArtContainer">
                {imagesSrc.gatsbyImageData ? (
                  <CPImage gatsbyImageData={imagesSrc.gatsbyImageData} />
                ) : (
                  <Image
                    src={imagesSrc.imageUrl}
                    size={maxWidth}
                    fullwidth={maxWidth === 'full-size'}
                    style={{
                      maxWidth: maxWidth !== 'full-size' ? maxWidth : undefined,
                    }}
                  />
                )}
              </div>
            </CarouselItem>
          ))}
      </Carousel>
    </>
  );

  const CustomArt = () => {
    if (customArt?.show) {
      const media = customArt?.images;
      const { maxWidth = 256 } = customArt;
      return (
        <Column size={width > desktopscreensize ? 4 : 12} className="m-auto">
          {media?.length === 1 ? (
            renderSingleImage(media, maxWidth)
          ) : media?.length >= 4 ? (
            <Gallery
              media={media}
              maxWidth={maxWidth}
              type="vertical"
              variant={variant}
            />
          ) : (
            renderCarousel(media, maxWidth)
          )}
        </Column>
      );
    }
    return <></>;
  };

  const rendermultiImageaVariant = () => (
    <Columns
      multiline={false}
      className={`${
        width <= tabletscreensize
          ? 'is-flex is-flex-direction-column-reverse'
          : null
      }`}
    >
      <TitleDescription />
      {width <= tabletscreensize ? (
        <Column>{renderCarousel(customArt?.images, '100%')}</Column>
      ) : (
        <CustomArt />
      )}
    </Columns>
  );

  const renderSingleImageVariant = () => {
    return (
      <>
        {width <= widescreensize ? (
          <Columns>
            {width <= tabletscreensize ? (
              <Column> {renderAboutUsHeading()} </Column>
            ) : null}
            <Column className="aboutUsImage">
              {renderSingleImage(customArt?.images, '100%')}
            </Column>
            <Column className="is-flex is-align-items-center">
              <Card id="aboutUsCardText" className="aboutUsCardText">
                {renderTitleDescription()}
              </Card>
            </Column>
          </Columns>
        ) : (
          <div className="is-flex is-align-items-center">
            {renderSingleImage(customArt?.images, '100%')}
            <Card id="aboutUsCardText" className="aboutUsCardText">
              {renderTitleDescription()}
            </Card>
          </div>
        )}
      </>
    );
  };

  return (
    <div
      className={`aboutUsContainer has-background-${sectionBackgroundColor}`}
    >
      <Container>
        {customArt?.images?.length === 1
          ? renderSingleImageVariant()
          : rendermultiImageaVariant()}
      </Container>
    </div>
  );
};
